import { useQuery } from '@tanstack/react-query';
import type { MarketingDashboardQuery } from '@troia-v3/types';

import { dashboardsMarketingApi } from '../services/dashboardsMarketingApi';

const QUERY_KEY = 'dashboards-marketing';

/**
 * Fetches o payload do dashboard de marketing para um período + filtros.
 *
 * Habilitado quando os params do modo são suficientes:
 * - week    → sempre habilitado
 * - month   → exige year+month
 * - year    → exige year
 * - custom  → exige startDate+endDate
 *
 * Cache 60s.
 */
export const useMarketingDashboard = (params: MarketingDashboardQuery) => {
  const enabled = (() => {
    if (params.period === 'week') return true;
    if (params.period === 'month') return !!params.year && !!params.month;
    if (params.period === 'year') return !!params.year;
    if (params.period === 'custom') return !!params.startDate && !!params.endDate;
    return false;
  })();

  return useQuery({
    queryKey: [
      QUERY_KEY,
      params.period,
      params.year,
      params.month,
      params.startDate,
      params.endDate,
      params.funnelId,
      params.source,
    ],
    queryFn: () => dashboardsMarketingApi.get(params),
    staleTime: 60_000,
    enabled,
  });
};
